import React, { Component, createRef } from "react";
import { observer } from "mobx-react";
import PropTypes from "prop-types";
import { CardElement } from "@stripe/react-stripe-js";
import { Button, Form, Icon, Loader, Ref } from "semantic-ui-react";
import { withTranslation } from "react-i18next";
import { getValidationErrors } from "~/utils/ReactReformed/ValidateSchema";
import CreditCardFormStore from "~/stores/Credit/CreditCardFormStore";
import ProviderStore from "~/stores/Provider/ProviderStore";
import StickyMenu from "~/components/StickyMenu";
import CreditCardFormFields from "~/modules/BillingCentral/components/CreditCardFormFields";
import ToastMessageStore from "~/stores/ToastMessageStore";
import CustomerStore from "~/stores/CustomerStore";

@observer
class CreditCardForm extends Component {
  ref = null;

  constructor(props) {
    super(props);

    this.ref = createRef();
    this.submit = this.submit.bind(this);
  }

  submit(evt) {
    evt.preventDefault();

    const {
      creditCardFormStore,
      actualUserStore,
      stripe,
      elements,
      creditCardCreatedCallback,
      toastMessageStore,
      t,
    } = this.props;

    const { actualUser } = actualUserStore;
    const { creditCardStore } = creditCardFormStore;

    const { model } = creditCardFormStore.formStore;

    const cardElement = elements.getElement(CardElement);

    // VViau: there is a problem here: stripe says it want 2 char country code... We get 3 here.
    const cardData = {
      name: model.nameOnCard,
      address_line1: model.street,
      address_line2: model.street2,
      address_city: model.city,
      address_state: model.state,
      address_country: actualUser.address.country, // "US"
      currency: actualUser.currency,
    };

    stripe
      .createToken(cardElement, cardData)
      .then(response => {
        if (typeof response.error !== "undefined") {
          creditCardStore.setErrorMessages({ status: "error", message: response.error.message });
          return;
        }

        const data = {
          stripeToken: response.token,
          nameOnCard: model.nameOnCard,
          saveCreditCard: model.saveCreditCard,
          isDefault: model.isDefault,
        };

        creditCardStore.create(data).then(() => {
          toastMessageStore.addToastMessage(t("billingCentral:creditCardHasBeenAdded"), "positive", t("success"));
          creditCardCreatedCallback();
        });
      })
      .catch(); /* e => {
        // console.error("Could not get Stripe Token", e);
      }); */
  }

  render() {
    const { creditCardFormStore, actualUserStore, t } = this.props;
    const { creditCardStore, formStore } = creditCardFormStore;
    const { model } = formStore;
    const { errorMessages: creditCardErrorMessages } = creditCardStore;
    const { isLoading: actualUserLoading } = actualUserStore;

    const serverValidationErrors = { ...creditCardErrorMessages };

    const validationRules = {
      nameOnCard: {
        required: true,
      },
    };
    const validation = getValidationErrors(validationRules, model);

    if (actualUserLoading) {
      return (
        <div className="side-page-loader">
          <Loader active inline="centered" />
        </div>
      );
    }

    return (
      <Ref innerRef={this.ref}>
        <div>
          <StickyMenu
            contextRef={this.ref}
            hideHeaderWhenIsNotSticky
            headerText={t("billingCentral:addCreditCard")}
            button={
              <div className="side-page-save-btn-wrap">
                <Button primary icon disabled={!validation.isValid} onClick={this.submit}>
                  <Icon name="save" />
                  {t("saveChanges")}
                </Button>
              </div>
            }
          />

          <Form className="side-page-form-wrap">
            <CreditCardFormFields
              formStore={formStore}
              validation={validation}
              serverValidationErrors={serverValidationErrors}
              showSaveCreditCardField={false}
              showIsDefaultField
            />
          </Form>
        </div>
      </Ref>
    );
  }
}

CreditCardForm.propTypes = {
  creditCardFormStore: PropTypes.instanceOf(CreditCardFormStore),
  actualUserStore: PropTypes.oneOfType([PropTypes.instanceOf(ProviderStore), PropTypes.instanceOf(CustomerStore)]),
  t: PropTypes.func.isRequired,
  stripe: PropTypes.object,
  elements: PropTypes.object,
  creditCardCreatedCallback: PropTypes.func.isRequired,
  toastMessageStore: PropTypes.instanceOf(ToastMessageStore),
};

export default withTranslation()(CreditCardForm);
